import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailIcon } from "lucide-react";

interface EmailInputProps {
  email: string;
  setEmail: (email: string) => void;
  readOnly?: boolean;
  label: string;
  placeholder: string;
}

export const EmailInput = ({ 
  email, 
  setEmail, 
  readOnly = false,
  label,
  placeholder 
}: EmailInputProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="email" className="text-sm font-medium text-gray-200">{label}</Label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <MailIcon className="h-4 w-4 text-blue-400" />
        </div>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="pl-10 bg-gray-800/50 border-gray-700 focus:border-blue-500 focus:ring-blue-500/20 transition-all duration-200"
          placeholder={placeholder}
          readOnly={readOnly}
        />
      </div>
    </div>
  );
};